import * as React from 'react';
import AssetsManager from '../utils/AssetsManager';

const LandingFeature = ({icon, title, text = '', option = true}) => {
    return option ? <div className="row landing-feature mb-3 mt-3">
        <div className="col">
            <div className="icon d-flex align-items-center justify-content-center">
                <img src={
                    AssetsManager(icon)
                } className="img-fluid" alt="check"/>
            </div>
            <div className="title mt-4 mb-4">
                {title}
            </div>
            <div className="description">
                {text}
            </div>
        </div>
    </div> : <div className="row landing-feature-option mb-3 mt-3">
        <div className="col d-flex align-items-center px-0">
            <div className="icon d-flex align-items-center justify-content-center">
                <img src={
                    AssetsManager(icon)
                } className="img-fluid" alt="check"/>
            </div>
            <div className="title mt-4 mb-4">
                <span dangerouslySetInnerHTML={{__html: title}}/>
            </div>
        </div>
    </div>;
};

export default LandingFeature;